export class SyncTransportError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.name = 'SyncTransportError';
        this.kind = kind;
    }
}
//# sourceMappingURL=transport.js.map